<template>
    <div>
        <message-builder
            v-model="message.body"
            v-model:mediaUrl="message.media_url"
            v-model:mediaContentType="message.media_content_type"
            @selected:snippet="isSnippetUsed = true"
            @submit="submit()"
            @schedule="
                message.send_at = $event;
                submit();
            "
            :disableSchedule="!onCorporate()"
            :disabled="isMessagingDisabled"
        >
            <template v-slot:actions v-if="FEATURES.message_hub_ai">
                <vx-dropdown-item @click.prevent="aiModal = true">
                    <span class="vx-flex vx-items-center vx-gap-1">
                        <font-awesome-icon :icon="faWandMagicSparkles" class="vx-text-sm"></font-awesome-icon>
                        <span>AI Message</span>
                        <experimental-pill class="vx-pointer-events-none" placement="right"></experimental-pill>
                    </span>
                </vx-dropdown-item>
            </template>
            <template v-if="isNotActive()" v-slot:alert>
                <vx-alert color="info" :closeable="false"> <strong>Disabled:</strong> Team is not active. </vx-alert>
            </template>
            <template v-else-if="!isContactSubscribed" v-slot:alert>
                <vx-alert color="info" :closeable="false">
                    <strong>Disabled:</strong> Contact has opted out of transactional messages.
                </vx-alert>
            </template>
            <template v-else-if="!loadingPhoneNumbers && !isPhoneNumberSet" v-slot:alert>
                <vx-alert color="info" :closeable="false">
                    <strong>Disabled:</strong> No phone numbers are available to send messages.
                </vx-alert>
            </template>
        </message-builder>
        <message-builder-message-hub-generation
            v-model:visible="aiModal"
            v-if="FEATURES.message_hub_ai"
            :contact-id="contact.id"
            @selected="message.body = $event"
        />
    </div>
</template>
<script setup>
import MessageBuilder from '~/components/general/message-builder/MessageBuilder.vue';
import { inject } from 'vue';
import { VxDropdownItem, VxAlert, VxSwal } from '@voxie/frontend-components';
import { faWandMagicSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ExperimentalPill from '~/components/general/ExperimentalPill.vue';
import MessageBuilderMessageHubGeneration from '~/components/general/message-builder/modals/MessageBuilderMessageHubGeneration.vue';
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import { isNotActive } from '~/utils/team';
import { useConversation } from '~/composables/useConversation';
import { ref } from 'vue';
import { actionsClient } from '~/services';
import { catchRequestError } from '~/utils/request';

const FEATURES = inject('FEATURES');
const { contact } = useContactDetails();
const { onCorporate } = useCurrentGroup();
const { message, deliverMessage, isMessagingDisabled, loadingPhoneNumbers, isPhoneNumberSet, isContactSubscribed } =
    useConversation();

const aiModal = ref(false);
const isSnippetUsed = ref(false);
const submit = async () => {
    try {
        if (isMessagingDisabled.value) {
            return;
        }

        await deliverMessage(true);

        if (isSnippetUsed.value) {
            await actionsClient.send('snippet_used');
            isSnippetUsed.value = false;
        }
    } catch (e) {
        VxSwal.fire({
            title: 'Whoops!',
            text: catchRequestError(e),
            icon: 'error',
        });
    }
};
</script>
